export default () => ({
  showModal: false,
  showModalProfileProfessional: false,
  entities: 'schedules',
  schedules: [],
  currentSchedule: {}
})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/resources/data.js